// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  display: flex;
  flex-direction: column;
  height: 40vh;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.dashboard-grid {
  display: grid;
  margin-top: 1rem;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  height: calc(100vh - 80px); /* Adjust based on header height */
}

.dashboard-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.dashboard-title {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  font-size: 1.2rem;
  font-weight: 390;
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .dashboard-container {
    padding: 10px;
  }
  
  .dashboard-card {
    padding: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Styles/UserDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,SAAS;EACT,0BAA0B,EAAE,kCAAkC;AAChE;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".dashboard-container {\n  display: flex;\n  flex-direction: column;\n  height: 40vh;\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.dashboard-grid {\n  display: grid;\n  margin-top: 1rem;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  height: calc(100vh - 80px); /* Adjust based on header height */\n}\n\n.dashboard-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard-title {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 1.2rem;\n  font-weight: 390;\n  text-align: center;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .dashboard-grid {\n    grid-template-columns: 1fr;\n    grid-template-rows: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-container {\n    padding: 10px;\n  }\n  \n  .dashboard-card {\n    padding: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
